// @ts-strict-ignore
import React, { useState } from 'react';

import { Box } from 'components/Box';
import { FormContainer as Form, Section } from 'components/Form';
import { BodySmall, H3 } from 'components/Text';
import { useCurrentUser } from 'store/main/hooks';
import { postJson } from 'utils/http';
import { resetRecaptcha } from 'utils/recaptcha';

import { SupportContactFormBlockContactForm } from './SupportContactFormBlockContactForm';
import { SupportContactFormBlockReason } from './SupportContactFormBlockReason';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormValues = Record<string, any>;

const handleSubmit = (
  { handleError, updateSubmitting, values },
  blockId,
  currentUser,
  setSubmittedValues: (values: FormValues | null | undefined) => void
) => {
  const { orgs = [] } = currentUser || {};
  const { id: orgId = '' } =
    orgs.find((org) => org.name === values.orgName) || {};
  const valuesToSubmit = {
    orgId,
    ...values,
    attachmentIds: values.attachmentIds.filter(Boolean),
  };
  postJson(`/data/website/support-contact-form/${blockId}`, valuesToSubmit)
    .then(() => {
      updateSubmitting(false);
      setSubmittedValues(valuesToSubmit);
    })
    .catch((e) => {
      resetRecaptcha();
      handleError(e, {
        recaptchaKey: values.recaptchaKey + 1,
        gRecaptchaResponse: undefined,
      });
    });
};

type Props = {
  blockId: string;
  data: {
    reasons: Array<SupportContactFormBlockReason>;
  };
};

export function SupportContactFormBlock({ blockId, data }: Props) {
  const currentUser = useCurrentUser();

  const initialValues = {
    email: currentUser && currentUser.email,
    firstName: currentUser && currentUser.firstName,
    lastName: currentUser && currentUser.lastName,
    locale: CURRENT_LOCALE,
    attachmentIds: [''],
  };
  const [submittedValues, setSubmittedValues] = useState<
    FormValues | null | undefined
  >();
  const { reasons } = data;
  const submitedWithReasonFeedback =
    submittedValues && submittedValues.reason === 'FEEDBACK';

  if (submittedValues)
    return (
      <Box m={64} textAlign="center">
        <H3>{getText('Thanks for submitting')}</H3>
        <BodySmall>
          {submitedWithReasonFeedback
            ? getText(
                'We’ll make sure to consider your feedback and will get back to you when we can!'
              )
            : getText('Someone will respond to you shortly.')}
        </BodySmall>
      </Box>
    );

  return (
    <Section>
      <Form
        data-qa-id="support-contact-form"
        initialValues={
          initialValues as typeof initialValues & {
            reason?: string;
            subReason?: string;
          }
        }
        onSubmit={(formContext) =>
          handleSubmit(formContext, blockId, currentUser, setSubmittedValues)
        }
        render={({ getValue, updateValue }) => {
          const selectedReason = reasons.find(
            (r) => r.id === getValue('reason')
          );
          const selectedSubReason =
            selectedReason &&
            selectedReason.subReasons &&
            selectedReason.subReasons.find(
              (s) => s.id === getValue('subReason')
            );
          return (
            <SupportContactFormBlockContactForm
              reasons={reasons}
              selectedReason={selectedReason}
              selectedSubReason={selectedSubReason}
              updateValue={updateValue}
            />
          );
        }}
      />
    </Section>
  );
}
